
import Loading from 'vue-loading-overlay';
import { ImageScanImportService } from '@/services/import/imageScanImportService.js';
import { required } from "vuelidate/lib/validators";
import CONFIG from "@/assets/js/config.js";
export default {
    name: 'ImportForm',
    props: ['scanFileType'], 
    components: {
        Loading,
    },
    data() {
      return {
        isLoading: false,
        importFileName: '',
        invalidFile: '',
        submitted: false,
        disabled: false,
        importFile: '',
      };
    },
    validations: {
        importFile: {
            required
        }
    },
    methods: {
        /**
         * Downloads the document template based on the specified scan file type.
         * Displays a success or error notification based on the result of the download.
         *
         * @async
         * @function downloadDocTemplate
         * @returns {Promise<void>} A promise that resolves when the download process is complete.
         */
        async downloadDocTemplate() {
            this.isLoading = true;
            let result = await ImageScanImportService.downloadDocumentTemplate(this.scanFileType);
            if (result.success) {
                this.$notification.success(result.message, {
                    timer: 3,
                    position: "bottomCenter"
                });
            } else {
                this.$notification.error(result.message, {
                    timer: 3,
                    position: "bottomCenter"
                });
            }
            this.isLoading = false;
        },

        /**
         * Trigger file input click
         */
        chooseFile() {
          this.$refs.fileUploader.value = '';
          document.getElementById('file-upload').click();
        },

        /**
         * Handle file input change
         */
        onImportFileChange() {
          this.invalidFile = false;
          let selectedFile = document.getElementById('file-upload').files;
          if (selectedFile.length) {
            let file = selectedFile[0];
            if (file.size > CONFIG.SCAN_IMAGE_FILE_SIZE) {
                this.$notification.error(CONFIG.SCAN_IMAGE_FILE_SIZE_ERROR, {
                    timer: 3,
                    position: "bottomCenter",
                });
                return false;
            }
            if (file.type.includes("image/")) {
                if (file.type == "image/gif") {
                    this.invalidFile = true;
                } else {
                    this.invalidFile = false;
                    this.importFileName = file.name;
                    this.importFile = file;
                }
            } else {
                this.invalidFile = true;
            }
          }
          this.disabled = false;
        },

        /**
         * Clear selected file
         */
        clearFile() {
          this.importFile = '';
          this.importFileName = '';
          document.getElementById('file-upload').value = '';
          this.submitted = false;
          this.disabled = false;
          this.invalidFile = false;
        },

        /**
         * Scans an image file and emits the result.
         * 
         * This method performs validation on the input form, and if valid, 
         * it calls the ImageScanImportService to scan the provided image file.
         * 
         * @async
         * @function scanImage
         * @returns {Promise<void>} A promise that resolves when the scan operation is complete.
         * @emits scanned {Object} The result of the scan operation if successful.
         * @throws {Error} If the scan operation fails, an error notification is displayed.
         */
        async scanImage() {
            this.isLoading = true;
            this.submitted = true;
            this.disabled = true;
            this.$v.$touch();
            if (this.$v.$invalid) {
                this.disabled = false;
                this.isLoading = false;
                return;
            } else {
                let result = await ImageScanImportService.scanImageFileData(this.importFile, this.scanFileType);
                this.isLoading = false;
                this.disabled = false;
                if (result.success) {
                    this.$emit('scanned', result); 
                } else {
                    this.$notification.error(result.message, {
                        timer: 3,
                        position: "bottomCenter"
                    });
                }
            }
        },
    }
};
